import { keyframes } from '@emotion/css'
import styled from '@emotion/styled'
import React from 'react'

const ogBaseColor = '#ebebeb'
const ogHighlightColor = '#f5f5f5'
const animationDuration = '1.5s'
const animationDirection = 'normal'
const PseudoElementDisplay = 'block'
const loadingAnim = keyframes`
    0%{
        transform: translateX(0%);
    }
    100%{
        transform: translateX(100%);
    }
`
interface SkeletonProps {
    baseColor?: string
    highlightColor?: string
    height?: string
}
const StyledSkeleton = styled('div')<SkeletonProps>(
    ({ baseColor, highlightColor, height }) => ({
        width: '100%',
        borderRadius: '0.25rem',
        display: 'inline-flex',
        lineHeight: 1,
        position: 'relative',
        overflow: 'hidden',
        zIndex: 1,
        height: height,
        backgroundColor: baseColor,
        '&:after': {
            content: `''`,
            display: PseudoElementDisplay,
            position: 'absolute',
            left: '0',
            right: '0',
            height: '100%',
            backgroundRepeat: 'no-repeat',
            backgroundImage: `linear-gradient(90deg, ${baseColor}, ${highlightColor}, ${baseColor})`,
            transform: 'translate(-100%)',
            animation: `${loadingAnim} ${animationDuration} ease-in-out infinite `,
        },
    }),
)

export function SkeletonComponent({
    baseColor = ogBaseColor,
    highlightColor = ogHighlightColor,
    height = '100%',
}: SkeletonProps) {
    return (
        <StyledSkeleton
            baseColor={baseColor}
            highlightColor={highlightColor}
            height={height}
        ></StyledSkeleton>
    )
}
